import $ from 'jquery';

var $revealElement = $( '[data-reveal]' ),
		windowHeight = 0;

const getNewElements = function() {
	$revealElement = $( '[data-reveal]' );
}

var variablesResizeHandler = function() {
	windowHeight = $( window ).height();
};
variablesResizeHandler();
$( window ).on( 'resize', variablesResizeHandler );

// Reveal animations
var checkIfInView = function() {
	$revealElement = $revealElement.not( '.in-view' );

	var viewportTop = $( window ).scrollTop();
	var viewportBottom = viewportTop + windowHeight;

	$revealElement.each( function() {
		var $self = $( this );
		var elementHeight = $self.outerHeight();
		var elementPositionTop = $self.offset().top;
		var elementPositionBottom = elementHeight + elementPositionTop;
		var elementTopOffset = $self.attr( 'data-reveal-offset' );

		if ( elementTopOffset ) {
			elementPositionTop += Number( elementTopOffset );
			elementPositionBottom += Number( elementTopOffset );
		}

		if (
			( elementPositionBottom >= viewportTop ) &&
			( ( elementPositionTop + 10 ) <= viewportBottom )
		) {
			$self.addClass( 'in-view' );

			if ( 'true' === $self.attr( 'data-reveal-trigger-event' ) ) {
				$self.trigger( 'slicejack.reveal.inView' );
			}
		}
	} );
};

setTimeout( function() {
	$( window ).on( 'scroll.checkIfInView resize.checkIfInView', checkIfInView );
	checkIfInView();
}, 300 );

export { getNewElements, checkIfInView };
